import classes from '@/App.module.scss';
import RigCalibration from '@/components/RigCalibration/RigCalibration';
import { ContentSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton';
import PageHeader from '@/components/PageHeader/PageHeader';
import { useLanguage } from '@/i18n/LanguageContext';

import { Button } from '@mantine/core';
import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import IconArrowLeft from '@tabler/icons-react/IconArrowLeft';

export default function PageRigCalibration() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className={classes.calibrationPage}>
      <PageHeader
        title={t('calibration.title')}
        actions={(
          <Button
            variant="subtle"
            color="green"
            size="sm"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate('/inference_results')}
          >
            {t('calibration.backToResults')}
          </Button>
        )}
      />
      <div className={classes.reportTable}>
        <Suspense fallback={<ContentSkeleton />}>
          <RigCalibration />
        </Suspense>
      </div>
    </div>
  );
}

